import { FormControl } from '@angular/forms';

export interface FormTemplateFieldAutopopulateConfig {
  incomingDataValuePath: string;
  mapConditionConfig: MapConditionConfig;
  transformValueConfig: TransformValueConfig;
  nonModifiable?: boolean;
}

export enum DescriptiveTextTypeEnum {
  pre, // prepends a string value to the incoming value
  post, // appends a string value to the incoming value
  preAndPost // prepends and appends string values to the incoming value
}

export interface DescriptiveTextTypeConfig {
  type: DescriptiveTextTypeEnum;
}

export type PreDescriptiveTextConfig = {
  type: DescriptiveTextTypeEnum.pre;
  preDescriptiveText: string;
};

export type PostDescriptiveTextConfig = {
  type: DescriptiveTextTypeEnum.post;
  postDescriptiveText: string;
};

export type PreAndPostDescriptiveTextConfig = {
  type: DescriptiveTextTypeEnum.preAndPost;
  preDescriptiveText: string;
  postDescriptiveText: string;
};

// Modify the autofilled value by adding text to it (e.g '8 hours')
export type DescriptiveTextConfig =
  | PreDescriptiveTextConfig
  | PostDescriptiveTextConfig
  | PreAndPostDescriptiveTextConfig;

/************************** TRANSFORM CONFIG **************************/
export enum TransformValueTypeEnum {
  date, // transform into date object
  sum, // form control value = form control value + incoming value
  map, // Map of incoming values to the values that will be set as the form control value
  specifyValue, // Specify the value which will be set as the form control value
  scale, // Multiply the value by a specified multiplier
  custom, // Enter a custom function
  none // No transformation will be applied. The incoming value will set as the form control value,
}

export enum DisplayFormatEnum {
  list, // form control value = form control value + '\n' + incoming value,
  medication,
  appendText, // Assumes value is a string. Appends to the current form control value + '\n'
  none // No display format needed
}

export type CustomTransformation = {
  type: TransformValueTypeEnum.custom;
  fn: (formControl: FormControl, incomingValue: any) => any;
};

export type DateTransformation = {
  type: TransformValueTypeEnum.date;
  format: string;
};

export type SpecifyValueTransformation = {
  type: TransformValueTypeEnum.specifyValue;
  value: any;
};

export type MapTransformation = {
  type: TransformValueTypeEnum.map;
  map: { [key: string]: any };
};

export type SumTransformation = {
  type: TransformValueTypeEnum.sum;
};

export type NoTransformation = {
  type: TransformValueTypeEnum.none;
};

export type ScaleTransformation = {
  type: TransformValueTypeEnum.scale;
  multiplier: number;
};

export type TransformValueTypeConfig =
  | DateTransformation
  | SpecifyValueTransformation
  | SumTransformation
  | MapTransformation
  | ScaleTransformation
  | CustomTransformation
  | NoTransformation;

export interface TransformValueConfig {
  typeConfig: TransformValueTypeConfig;
  displayFormat: DisplayFormatEnum;
  descriptiveTextConfig?: DescriptiveTextConfig;
}

/******************************************** MAP CONDITION CONFIG ********************************************/

export interface MapConditionConfig {
  comparisonValue?: any;
  comparisonOperator: CompareOperator;
}

export enum CompareOperator {
  equals = '=',
  lessThan = '<',
  lessThanOrEqual = '<=',
  greaterThan = '>',
  greaterThanOrEqual = '>=',
  notEmpty = '!empty',
  notEqual = '!=',
  none = 'none'
}
